export default {"src":"/_next/static/media/heli-desktop-logo.71e3bf67.gif","height":134,"width":760,"blurWidth":0,"blurHeight":0};